import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-485e81ea")

_pushScopeId("data-v-485e81ea")
const _hoisted_1 = { class: "ui__baseInfo_main" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "ui__baseInfo_title" }, " 基础信息 ", -1)
const _hoisted_3 = { class: "ui__baseInfo_content" }
const _hoisted_4 = { class: "ui_baseInfo_content_item_label" }
const _hoisted_5 = { class: "ui_baseInfo_content_item_value" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.dataList, (item) => {
        return (_openBlock(), _createBlock("div", {
          class: "ui_baseInfo_content_item",
          key: item.name
        }, [
          _createVNode("div", _hoisted_4, _toDisplayString(item.fieldName), 1),
          _createVNode("div", _hoisted_5, [
            (item.fieldValue)
              ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(item.fieldValue), 1))
              : (_openBlock(), _createBlock("span", _hoisted_7, "-"))
          ])
        ]))
      }), 128))
    ])
  ]))
})